<hc-sidenav
    [tabs]="tabs"
    [tabGroups]="tabGroups"
    [width]="width"
    [showFavorites]="false"
    [collapsed]="!isOpen"
    (collapsedChange)="onCollapsedChange($event)"
    class="cdp-sidenav"
    routerLinkActiveClass="cdp-sidenav-active-tab"
>
    <!-- Tenant Header Widget -->
    <!-- TODO: use tenant logo when we have it -->
    <!-- <div *ngIf="tenantLogo" class="tenant-logo"></div> -->
    <div hcSidenavHeader class="tenant-widget" title="{{ tenantLoadFailed ? 'Failed to load tenant' : '' }}">
        <ng-container *ngIf="!tenantLoadFailed">
            <h2 *ngIf="!loadingTenant" class="cdp-fade-in">
                {{ tenant?.name }}
            </h2>
            <h2 *ngIf="loadingTenant" class="skeleton-tenant-header cdp-subtle-pulse"></h2>
            <div class="tenant-widget-detail">
                <span
                    *ngIf="!loadingTenant"
                    title="{{ tenant?.activeFlag ? 'Tenant is active' : 'Tenant is inactive' }}"
                    class="tenant-status-ico {{ tenant?.activeFlag ? 'icon-status-success' : 'icon-status-cancelled' }}"
                ></span>
                <span *ngIf="!loadingTenant">{{ tenant?.tenantId }}</span>
                <hc-progress-spinner
                    *ngIf="loadingTenant"
                    [diameter]="12"
                    [color]="'white'"
                    [isCentered]="false"
                ></hc-progress-spinner>
            </div>
        </ng-container>
        <span *ngIf="tenantLoadFailed" class="icon-warn tenant-widget-fail-ico cdp-fade-in"></span>
    </div>
    <!-- end tenant header widget -->

    <div hcSidenavFooter>
        <ng-content></ng-content>
    </div>
</hc-sidenav>
